export default function () {
  if (document.getElementById('multioffice-modal-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "multioffice-modal-app" */ '@organisms/office-chooser/main');
  }
}
